import { TravelerKinds } from "utils/constants";

// Derived from the filled fields rather than read off the row, so it also works on a payload-shaped
// record — the create preview renders one.
export const resolveTravelerKind = traveler => {
  if (traveler?.employeeId) return TravelerKinds.Employee;
  if (traveler?.facultyNumber) return TravelerKinds.Student;
  if (traveler?.faculty) return TravelerKinds.Doctoral;
  return TravelerKinds.External;
};

// `travelerKind` only drives which inputs a traveler row renders — it must never reach the backend.
export const toTravelersFormValues = travelers =>
  (travelers ?? []).map(t => ({ ...t, travelerKind: resolveTravelerKind(t) }));

export const toTravelersPayload = travelers =>
  (travelers ?? []).map(t => {
    switch (t.travelerKind) {
      case TravelerKinds.External:
        return {
          fullName: t.fullName,
          contractNumber: t.contractNumber || null,
          contractDate: t.contractDate || null,
          hasOtherEmployer: !!t.hasOtherEmployer,
          employerConsentProvided: !!t.employerConsentProvided,
        };
      case TravelerKinds.Student:
        return { fullName: t.fullName, faculty: t.faculty, facultyNumber: t.facultyNumber };
      case TravelerKinds.Doctoral:
        return { fullName: t.fullName, faculty: t.faculty, facultyNumber: null };
      // The employer/contract fields are rejected outright unless the traveler is a jury member,
      // so an employee row must omit them rather than send them as `false`.
      default:
        return { employeeId: t.employeeId };
    }
  });
